(function () {
  'use strict';

  var CARD_SEL = '.spark-pack-card[data-pack-variant-id]';
  var QTY_SEL = 'input[data-pack-quantity]';
  var ADD_SEL = 'button[name="add"], .spark-product-form__cart-button';
  var CHECKOUT_SEL = '[name="checkout"], button[name="checkout"], .cart__checkout-button';
  var FORM_SEL = 'form[action*="/cart/add"]';
  var BLUE = '#0085C9';
  var BUILDER_URL = 'https://media.futuremakers.rocks/i/QuoteBuilder/cart-quote.html?v=20260805a';
  var HIDE_CHECKOUT_STYLE_ID = 'fm-quote-hide-checkout-style';
  var BUTTON_STYLE_ID = 'fm-quote-button-style';

  function quoteIntent() {
    var value = window.__fmQuoteIntent;
    return value === true || value === 'true';
  }

  function collectItems(root) {
    var items = [];
    var cards = root.querySelectorAll(CARD_SEL);

    if (cards.length) {
      Array.prototype.forEach.call(cards, function (card) {
        var input = card.querySelector(QTY_SEL);
        var quantity = input ? parseInt(input.value, 10) : 0;
        var id = card.getAttribute('data-pack-variant-id');

        if (id && quantity > 0) {
          items.push({ id: Number(id), quantity: quantity });
        }
      });

      return items;
    }

    var addButton = root.querySelector(ADD_SEL);
    var form = addButton && addButton.form || root.querySelector(FORM_SEL);
    if (!form) return items;

    var idField = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    var id = idField ? idField.value : '';
    var qtyField = form.querySelector('input[name="quantity"]');
    var quantity = qtyField && qtyField.value !== '' ? parseInt(qtyField.value, 10) : 1;

    if (!quantity || quantity < 1) quantity = 1;
    if (id) items.push({ id: Number(id), quantity: quantity });

    return items;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || 'Request failed (' + response.status + ')');
          error.status = data.status;
          error.httpStatus = response.status;
          error.detail = data.detail;
          throw error;
        }

        return data;
      });
    });
  }

  function ensureQuoteButtonStyle() {
    if (document.getElementById(BUTTON_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = BUTTON_STYLE_ID;
    style.textContent = [
      '.fm-atq-button{width:100%;min-height:52px;padding:14px 18px;border-radius:14px;box-sizing:border-box;background:#fff;border:1px solid rgba(0,133,201,.16);color:' + BLUE + ';font-family:inherit;font-size:16px;font-weight:700;letter-spacing:.02em;line-height:1;text-transform:uppercase;text-decoration:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s ease,background-color .2s ease,color .2s ease,border-color .2s ease,box-shadow .2s ease;}',
      '.fm-atq-button:hover{background:' + BLUE + ';border-color:' + BLUE + ';color:#fff;box-shadow:0 10px 24px rgba(0,133,201,.18);transform:translateY(-1px);}',
      '.fm-atq-button:focus-visible{outline:3px solid rgba(0,133,201,.34);outline-offset:3px;}',
      '.fm-atq-button[disabled]{cursor:not-allowed;opacity:.68;transform:none;box-shadow:none;}',
      '.fm-atq-help{margin:0;font-family:Poppins,Arial,sans-serif;letter-spacing:0;text-align:center;text-transform:none;}',
      '.fm-atq-help__link{display:inline-block;color:' + BLUE + ';font-family:Poppins,Arial,sans-serif;font-size:16px;font-weight:700;letter-spacing:0;line-height:1.4;padding-top:15px;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:2px;text-transform:none;}',
      '.fm-atq-help__link::after{content:" \\2192";}',
      '.fm-atq-help__link:hover,.fm-atq-help__link:focus-visible{color:#006094;}'
    ].join('');
    document.head.appendChild(style);
  }

  function accountRegisterUrl() {
    return 'https://shop.futuremakers.fun/pages/tax-exempt';
  }

  function removeThemeQuoteLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('.spark-product-form__quote-button'), function (link) {
      link.remove();
    });
  }

  function initProduct() {
    removeThemeQuoteLinks();
    ensureQuoteButtonStyle();

    var addButton = document.querySelector(ADD_SEL);
    if (!addButton || document.querySelector('[data-fm-atq]')) return false;

    var hasPackCards = !!document.querySelector(CARD_SEL);
    var hasAddForm = !!(addButton.form || document.querySelector(FORM_SEL));
    if (!hasPackCards && !hasAddForm) {
      console.warn('[fm-quote] no ' + CARD_SEL + ' and no ' + FORM_SEL + ' on this page - button not shown.');
      return false;
    }

    var wrap = document.createElement('div');
    wrap.setAttribute('data-fm-atq', '');
    wrap.style.cssText = 'margin-top:0;display:flex;flex-direction:column;gap:5px;';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fm-atq-button';
    button.textContent = 'Add to quote';

    var help = document.createElement('p');
    help.className = 'fm-atq-help';

    var accountLink = document.createElement('a');
    accountLink.className = 'fm-atq-help__link type-helper-link type-helper-link-small';
    accountLink.href = accountRegisterUrl();
    accountLink.textContent = 'Tax exempt? Create an account';
    help.appendChild(accountLink);

    var error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.style.cssText = 'font-size:13.5px;line-height:1.45;color:#A3324B;text-align:center;margin:0;font-weight:600;';

    button.addEventListener('click', function () {
      if (button.getAttribute('aria-busy') === 'true') return;

      error.hidden = true;
      var items = collectItems(document);

      if (!items.length) {
        error.textContent = hasPackCards ? 'Choose a pack size and quantity first.' : 'Choose a quantity first.';
        error.hidden = false;
        return;
      }

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      postJSON('/cart/add.js', { items: items })
        .then(function () {
          return postJSON('/cart/update.js', { attributes: { quote_intent: 'true' } });
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          error.textContent = err.message || 'Sorry - that did not work. Please try again.';
          error.hidden = false;
        });
    });

    wrap.appendChild(button);
    wrap.appendChild(help);
    wrap.appendChild(error);
    addButton.insertAdjacentElement('afterend', wrap);

    return true;
  }

  function hideCheckoutForQuoteCart() {
    document.documentElement.classList.add('fm-quote-cart');

    if (document.getElementById(HIDE_CHECKOUT_STYLE_ID)) return;

    var css = CHECKOUT_SEL.split(',').map(function (selector) {
      return '.fm-quote-cart ' + selector.trim();
    }).join(', ') + ' { display: none !important; }';
    var style = document.createElement('style');
    style.id = HIDE_CHECKOUT_STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function initCart() {
    if (quoteIntent()) hideCheckoutForQuoteCart();

    var checkout = document.querySelector(CHECKOUT_SEL);
    if (!checkout || document.querySelector('[data-fm-caq]')) return false;

    var box = document.createElement('div');
    box.setAttribute('data-fm-caq', '');
    box.style.cssText = 'display:flex;flex-direction:column;gap:8px;';

    var button = document.createElement('button');
    button.type = 'button';
    button.style.cssText = blueButtonStyle('56px', '8px', '15px');
    button.textContent = 'Complete your quote';

    var error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.style.cssText = 'font-size:13.5px;line-height:1.45;color:#A3324B;text-align:center;margin:0;font-weight:600;';

    button.addEventListener('click', function () {
      if (button.getAttribute('aria-busy') === 'true') return;

      error.hidden = true;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) throw new Error('Your cart is empty.');

          var cartItems = cart.items.map(function (item) {
            var label = item.sku || item.product_title || item.title || 'item';
            return label + ':' + item.quantity;
          }).join(',');
          var params = new URLSearchParams();
          params.set('cartItems', cartItems);
          window.location.href = BUILDER_URL + (BUILDER_URL.indexOf('?') === -1 ? '?' : '&') + params.toString();
        })
        .catch(function (err) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          error.textContent = err && err.message || 'Sorry - that did not work. Please try again.';
          error.hidden = false;
        });
    });

    box.appendChild(button);
    box.appendChild(error);

    if (quoteIntent()) {
      box.style.marginBottom = '12px';
      checkout.insertAdjacentElement('beforebegin', box);
    } else {
      box.style.marginTop = '12px';
      checkout.insertAdjacentElement('afterend', box);
    }

    return true;
  }

  function init() {
    return initProduct() || initCart();
  }

  function observeProductSwaps() {
    if (window.__fmAddToQuoteObserver) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;

      window.setTimeout(function () {
        pending = false;
        initProduct();
      }, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.__fmAddToQuoteObserver = observer;
  }

  window.FutureMakersAddToQuote = {
    init: init,
    initProduct: initProduct,
    initCart: initCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observeProductSwaps();
    });
  } else {
    init();
    observeProductSwaps();
  }
})();
